// Shared constants for the Smartsheet feature
// Imported by ProjectSheetView, PhaseRow, TaskRow

export const STATUS_LABELS = {
  Open: "Open", InProgress: "In Progress", UnderValidation: "Under Validation",
  Hold: "On Hold", Completed: "Completed",
};

// Maps UI field names → TaskItem property names (single source of truth)
export const FIELD_KEY = {
  title:    "title",
  assignee: "assignedToUserId",
  due:      "dueDate",
  priority: "priority",
  status:   "status",
  atRisk:   "atRisk",
};

// Valid next-status options per current status (mirrors WorkflowRules.cs)
export const NEXT_STATUS = {
  Open:            ["InProgress", "Hold"],
  InProgress:      ["UnderValidation", "Hold"],
  Hold:            ["Open", "InProgress", "UnderValidation"],
  UnderValidation: ["Completed", "InProgress", "Hold"],
  Completed:       [],
};

export const COLS = [
  { id: "drag",     label: "",            width: 24,  align: "center", fixed: true },
  { id: "flag",     label: "",            width: 26,  align: "center", fixed: true },
  { id: "task",     label: "Task Name",   flex: 1,    minWidth: 200,   fixed: true },
  { id: "assignee", label: "Assigned To", width: 130 },
  { id: "due",      label: "Due Date",    width: 90  },
  { id: "priority", label: "Priority",    width: 84  },
  { id: "status",   label: "Status",      width: 148 },
];

export function colStyle(col) {
  return col.flex
    ? { flex: col.flex, minWidth: col.minWidth || 0 }
    : { width: col.width, flexShrink: 0, textAlign: col.align || "left" };
}

export const cellInputStyle = {
  width: "100%", fontSize: 12, padding: "3px 7px", borderRadius: 5,
  border: "1.5px solid #6366f1", outline: "none",
  background: "var(--surface)", color: "var(--text)", fontFamily: "inherit",
  boxShadow: "0 0 0 3px rgba(99,102,241,0.1)",
};

export const cellSelectStyle = {
  width: "100%", fontSize: 12, padding: "3px 5px", borderRadius: 5,
  border: "1.5px solid #6366f1", outline: "none",
  background: "var(--surface)", color: "var(--text)", cursor: "pointer",
  boxShadow: "0 0 0 3px rgba(99,102,241,0.1)",
};
